import React from "react";
import cn from "classnames";

export default function TokenPriceState(props: any) {
  let isPlus = Math.sign(props.value) === -1;
  return (
    <>
      {props.indicatorType === "background" ? (
        <div
          className={cn(
            " style-ltr ",
            isPlus ? "box box-sm box-sm-pink " : "box box-sm box-sm-green "
          )}
        >
          <div className="py-1 d-flex flex-row align-items-center justify-content-center ">
            <i
              className={cn(
                "",
                isPlus
                  ? "icon-arrow-down icon-arrow-down-white"
                  : "icon-arrow-up icon-arrow-up-white"
              )}
            />
            <span className="text-white fs-6 px-1  title-fs-mobile">
              {isPlus ? props.value : `+${props.value}`}
            </span>
          </div>
        </div>
      ) : (
        <div className=" fs-6 d-flex flex-row align-items-center ">
          <span
            className={cn(
              "px-2 style-ltr",
              isPlus ? "text-danger-light " : "text-success-light "
            )}
          >
            {isPlus ? props.value : `+${props.value}`}
          </span>
          <i className={isPlus ? "icon-arrow-down  " : "icon-arrow-up"} />
        </div>
      )}
    </>
  );
}
